import { useCreateDexcomSource as useCreateDexcomSourceAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"

import { useSources } from "./useSources"
import { useFollowedUsers } from "src/contexts"
import { useEventReloading } from "src/contexts/LoadingContexts"
import { noticeError } from "src/utils"

export function useCreateDexcomSource() {
  const { selfFollow } = useFollowedUsers()
  const createDexcomSource = useCreateDexcomSourceAPI()
  const { mutate } = useSources()
  const { requestReload } = useEventReloading()

  const selfFollowId = selfFollow.id

  const createSource = useMemo(
    () => !createDexcomSource ? undefined : async (code: string) => {
      try {
        const response = await createDexcomSource(code)

        void mutate()
        requestReload(selfFollowId)

        return response
      } catch (e) {
        noticeError(
          e,
          "CreateDexcomSource",
        )

        throw e
      }
    },
    [
      requestReload,
      createDexcomSource,
      mutate,
      selfFollowId,
    ],
  )

  return createSource
}
